export default {
  profitChip: {
    marginLeft: 10,
    padding: "2px 6px",
    borderRadius: 4,
    background: "#DDD",
    fontSize: "0.8em"
  }
};



// WEBPACK FOOTER //
// ./src/components/app/management/salesman-sales-report/styles.js